import React from 'react';
import {
  FDAlert, FDImage, FDStack, Paper,
} from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';

const MainContent = () => {
  const { resource } = useMetaLayoutContext();

  const isManualRollover = resource.withRelationship(fr.relationships.webview.name, () => false, () => true);
  const spacing = isManualRollover ? 3 : 2;
  const imageWidth = isManualRollover ? '180px' : '220px';
  const imageHeight = isManualRollover ? '45px' : '55px';

  return (
    <FDStack direction={'column'} alignItems={'center'} justifyContent={'center'}>
      <Paper appearance={'elevated'}>
        <FDStack direction={'column'} justifyContent={'center'} spacing={spacing} paddingX={4} paddingY={3}>
          <FDImage alt={'main-content-image'} alignSelf={'center'} width={imageWidth} height={imageHeight} src={resource.relationship(fr.relationships.mainContentImage.name).link('related').url()} />
          <MetaField attr="mainContentTitle" />
          <MetaField attr="mainContentDetails" />
          {resource.attr('contactInfoMessage') ? <FDAlert description={resource.attr('contactInfoMessage')} /> : null}
        </FDStack>
      </Paper>
    </FDStack>
  );
};

MainContent.defaultProps = {
};

MainContent.propTypes = {
};

export default MainContent;
